import {
  GET_ORGANISATIONS,
  ORGANISATION_RESPONSE_HANDLER,
  GET_ORGANISATION_CHECKOUT_PAGE,
} from "../actions/types";

export default (state = {}, action) => {
  let status = 400;
  let data = {};
  let notificationType = "info";
  if (
    action.payload != undefined &&
    typeof action.payload.status != "undefined"
  ) {
    status = action.payload.status;
    notificationType = "success";
    if (status >= 400) {
      notificationType = "error";
    }
    data = action.payload.data;
  }

  let response = {
    notificationType: notificationType,
    type: action.type,
    status: status,
    action: "LIST",
  };
  switch (action.type) {
    case GET_ORGANISATIONS:
      response["data"] = data.organisations;
      break;
    case ORGANISATION_RESPONSE_HANDLER:
      response["data"] = data;
      response["action"] = "ACTION";
      break;
    case GET_ORGANISATION_CHECKOUT_PAGE:
      response["data"] = data;
      response["action"] = "ACTION";
      break;

    default:
      return state;
  }
  return response;
};
